import { render } from "./ModifyView.vue?vue&type=template&id=89ecc16c"
import script from "./ModifyView.vue?vue&type=script&lang=ts"
export * from "./ModifyView.vue?vue&type=script&lang=ts"
script.render = render

export default script